import * as wf from "client-api-workflow";
import { useQuery } from "react-query";

const useAttachments = (params: { elementId?: string; period?: string }) => {
  return useQuery(
    JSON.stringify(["data-file-attachments", params.elementId, params.period]),
    () => {
      return wf.getAttachments({
        period: params.period!,
        parentId: params.elementId!,
      });
    },
    {
      enabled: !!params.elementId && !!params.period,
      staleTime: 2000,
    }
  );
};

export default useAttachments;
